/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ForceClassBulkEnrollmentRequest
 */
export interface ForceClassBulkEnrollmentRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ForceClassBulkEnrollmentRequest
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof ForceClassBulkEnrollmentRequest
     */
    studentIds: Array<ApiUserTasksGetPageParameter>;
}

/**
 * Check if a given object implements the ForceClassBulkEnrollmentRequest interface.
 */
export function instanceOfForceClassBulkEnrollmentRequest(value: object): value is ForceClassBulkEnrollmentRequest {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('studentIds' in value) || value['studentIds'] === undefined) return false;
    return true;
}

export function ForceClassBulkEnrollmentRequestFromJSON(json: any): ForceClassBulkEnrollmentRequest {
    return ForceClassBulkEnrollmentRequestFromJSONTyped(json, false);
}

export function ForceClassBulkEnrollmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForceClassBulkEnrollmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'studentIds': ((json['studentIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
    };
}

export function ForceClassBulkEnrollmentRequestToJSON(json: any): ForceClassBulkEnrollmentRequest {
    return ForceClassBulkEnrollmentRequestToJSONTyped(json, false);
}

export function ForceClassBulkEnrollmentRequestToJSONTyped(value?: ForceClassBulkEnrollmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'studentIds': ((value['studentIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
    };
}

